import React from 'react';
import DubbingProjectDetailContainer from '@src/containers/DubbingProjectDetail';

const DubbingProjectDetail = () => <DubbingProjectDetailContainer />;

export default DubbingProjectDetail;
